var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVolumeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.707 3.293a1 1 0 0 0-1.414 1.414L5.586 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3.307l4.455 3.51c1.312 1.034 3.238.1 3.238-1.571v-2.525l4.293 4.293a1 1 0 0 0 1.414-1.414l-16-16ZM13 14.414 7.569 8.983A2 2 0 0 1 7.307 9H4v6h3.307a2 2 0 0 1 1.238.429L13 18.939v-4.525Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 9.586V5.06l-2.53 1.994-1.425-1.424 2.717-2.141C13.074 2.456 15 3.39 15 5.061v4.11a3.001 3.001 0 0 1 1.708 4.122L13 9.586ZM19.008 15.594l1.448 1.448A8.96 8.96 0 0 0 22 12a8.99 8.99 0 0 0-3.752-7.312 1 1 0 0 0-1.167 1.624A6.99 6.99 0 0 1 20 12a6.968 6.968 0 0 1-.992 3.594Z",
  fill: "currentColor"
})));
export default SvgVolumeOff;